module.exports = __webpack_public_path__ + "img/aw.336bb1cc.svg";